import React from 'react'
import {
  Row,
  Col,
  Card,
  Table,
  Tag,
  Button,
  Badge,
  Popconfirm,
  Empty,
} from 'antd'
import { Moment, openNotificationWithIcon } from '../../../helpers'
import './style.scss'
import { Config } from '../../../config'
import { inject, observer } from 'mobx-react'
import 'react-fancybox/lib/fancybox.css'
import Gallery from '../../gallery/gallery-list'
import { JobStatus } from '../JobStatus'
import { JobDateTime } from '../JobDateTime'
import { JobTechnichian } from '../JobTechnichian'
import TableResponsiveOK from '../../_shared/responsive-table'
import {
  DashOutlined,
  CloseSquareFilled,
  CheckCircleOutlined,
} from '@ant-design/icons'
import { JobService, InformfixService } from '../../../services'
import { JobGalleryView } from '../JobGalleryView'

const IconText = ({ type, text }) => <span>{text}</span>

@inject('informStore')
@observer

/**
 * แสดงรายละเอียดเพื่อปิดงานเป็น งานๆ
 */
class JobClose extends React.Component {
  state = {}

  componentDidMount() {
    let items = []
    if (this.props.photos && this.props.photos.length > 0) {
      this.props.photos.map((item, key) => {
        items.push(item.url)
      })
    }
  }

  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountAllStatus() {
    console.log('check count inform')
    InformfixService.countNewInform().then((rs) => {
      if (rs) {
        console.log('countNewInform', rs.data)
        const data = rs.data
        this.props.informStore.countNewInform = data.total
      }
    })
    InformfixService.count4task().then((rs) => {
      console.log('count4task', rs)
      if (rs) {
        const data = rs.data
        this.props.informStore.count4task = data.total
      }
    })
    InformfixService.countPostpone().then((rs) => {
      if (rs) {
        console.log('countPostpone', rs.data)
        const data = rs.data
        this.props.informStore.countPostpone = data.total
      }
    })
  }

  closeJob = (row) => {
    JobService.close(row.id).then((rs) => {
      if (rs) {
        const data = rs.data
        const job = data.data.job
        const inform = data.data.informfix
        let informfix = this.props.informStore.getItem
        let jobs = this.props.informStore.getJobItems
        informfix.work_status = inform.work_status
        informfix.workStatusName = inform.workStatusName
        this.props.informStore.setItem(informfix)
        jobs.map((j, jk) => {
          if (j.id == job.id) {
            jobs[jk] = job
            this.props.informStore.setJobItems(jobs)
          }
        })
        this.props.onCloseJob({
          job: job,
          inform: informfix,
        })
        openNotificationWithIcon('success', data.message)
        this.getCountAllStatus()
      }
    })
  }

  render() {
    const jobs = this.props.informStore.getJobItems
    const inform = this.props.informStore.getItem

    // ชื่อช่าง
    const technicianName = (job) => {
      if (job.technicians && job.technicians.length > 0) {
        let name = ''
        let names = []
        job.technicians.map((v, tkey) => {
          if (v.technician) {
            if (v.technician) {
              names.push(
                <Tag key={tkey} color="">
                  ช่าง: {v.technician.firstname}
                </Tag>,
              )
            }
          }
        })
        return names
      }
    }

    // แสดงวันที่ from unix timestamp
    const showTimeFromUnix = (datetime) => {
      let date = Moment.unix(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }
    // แสดงวันที่
    const showTime = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }

    const showDetail = (record) => {
      return (
        <div
          style={{
            marginLeft: 20,
            fontSize: '12px',
          }}
        >
          {record.informFix ? (
            <div>
              <IconText type="bank" text={record.informFix.project.name} />
            </div>
          ) : null}

          {record.informFix ? (
            <div>
              <IconText
                type="home"
                text={'บ้านเลขที่ ' + record.informFix.home.home_no}
              />
              {'  '}
              <IconText
                type="home"
                text={' แปลง ' + record.informFix.home.plan_no}
              />
            </div>
          ) : null}
          {record.technicians && record.technicians.length > 0 ? (
            <div>
              <IconText
                type="user"
                text={record.technicians ? technicianName(record) : null}
              />
            </div>
          ) : null}
          {record.created_at > 0 ? (
            <div>
              <IconText
                type="calendar"
                text={
                  record.created_at
                    ? '' + showTimeFromUnix(record.created_at)
                    : '-'
                }
              />
            </div>
          ) : null}
        </div>
      )
    }

    return (
      <React.Fragment>
        {inform ? (
          <div
            style={{
              margin: '0 auto',
            }}
          >
            <Row align="top" gutter={[4, 4]}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
              >
                {jobs && jobs.length > 0 ? (
                  // <Table
                  //   bordered
                  //   size="small"
                  //   dataSource={jobs}
                  //   columns={columns}
                  //   pagination={false}
                  //   rowKey={(i) => {
                  //     return i.id
                  //   }}
                  // />
                  <React.Fragment>
                    {/* <TableResponsiveOK
                        columns={{ id: 'ID', start_time:'วันที่', list: 'หัวข้อ',description: 'รายละเอียด' }}
                        rows={jobs}
                      /> */}
                    {jobs.map((job, key) => (
                      <Card
                        key={key}
                        bodyStyle={{
                          padding: 7,
                          backgroundColor: '#f3f3f3',
                          color: '#222222',
                          border: 'solid 2px #cccccc',
                        }}
                        style={{
                          marginBottom: 7,
                        }}
                      >
                        {job.start_time?(
                         <div style={{ fontSize: '.7rem' }}>
                         <JobDateTime
                           datetime={job.start_time}
                           jobStatus={job.job_status}
                         />
                         {job.end_time ? ' - ' : null}
                         <JobDateTime
                           datetime={job.end_time}
                           jobStatus={job.job_status}
                         />
                         </div>
                        ):null}

                        <h3>{job.list}</h3>
                        <p>{job.description}</p>

                        <div>
                          ID#{job.id}{' '}
                          <JobStatus
                            name={job.jobStatusName}
                            statusId={job.job_status}
                          />
                          | ผู้รับผิดชอบ : {job.responsible_name}
                        </div>

                        {job.job_status != Config.job.status.COMPLETE.value ? (
                          <div>
                            <Popconfirm
                              title="งานนี้เสร็จแล้ว ต้องการปิดงานนี้ใช่หรือไม่ ?"
                              onConfirm={() => this.closeJob(job)}
                              okText="ใช่, งานเสร็จแล้ว"
                              cancelText="ไม่, ยังไม่เสร็จ"
                            >
                              <Button
                                size="small"
                                type="primary"
                                icon={<CheckCircleOutlined />}
                                color=""
                              >
                                กดปิดงาน
                              </Button>
                            </Popconfirm>
                          </div>
                        ) : null}
                        <JobTechnichian technicians={job.technicians} />
                        {job.beforeImages ? (
                          <JobGalleryView
                            job={job}
                            jobId={job.id}
                            defaultMode="view"
                            onReload={() => {}}
                          />
                        ) : null}
                      </Card>
                      // <Row gutter={[8, 8]} key={'job' + key}>
                      //   <Col xs={24} sm={10} style={{ fontSize: 12 }}>
                      //     {showTime(job.start_time)}
                      //     {job.end_time ? (
                      //       <span>- {showTime(job.end_time)}</span>
                      //     ) : null}
                      //   </Col>
                      //   <Col xs={24} sm={14}>
                      //     <strong>{job.list}</strong>
                      //     <p>
                      //       ช่าง:{' '}
                      //       <JobTechnichian technicians={job.technicians} />
                      //     </p>
                      //     <p>{job.description}</p>
                      //   </Col>
                      // </Row>
                    ))}
                  </React.Fragment>
                ) : (
                  <Empty />
                )}
              </Col>
            </Row>
          </div>
        ) : null}
      </React.Fragment>
    )
  }
}

export default JobClose
